// ==================================================================================================
//
// When link with anchor is clicked,
// ensure Aria resets to anchor position on new page
//
// ==================================================================================================
const initialAriaFocus = () => {
  let props = {};
  let els = {};

  // Cache dom element selectors
  // ------------------------------------------------
  const createChildren = () => {
    els.$main = $('.js-main')
    els.$skipNav = $('.js-skip-navigation')
  }

  // Force focus on main element
  // ------------------------------------------------
  const jumpToInitialAriaFocus = () => {
    // focus on <main> after page change for #a11y
    $('.js-main-content').focus()
  }

  // Force focus on main element
  // ------------------------------------------------
  const jumpToMain = (e) => {
    e.preventDefault()
    $('.js-main-content').focus()
  }

  // Enable
  // ------------------------------------------------
  const enable = () => {
    if (props.isEnabled) return;

    // If no visible errors exist, go ahead and jump to initial aria focus
    if ($('.js-form-error[aria-hidden="true"]').length) {
      jumpToInitialAriaFocus()
    }

    els.$skipNav.on('click', jumpToMain)

    props.isEnabled = true;
  }

  // Disable
  // ------------------------------------------------
  const disable = () => {
    if (!props.isEnabled) return;

    // Remove your event handlers here
    els.$skipNav.off('click', jumpToMain)

    props.isEnabled = false;
  }

  // Init
  // ------------------------------------------------
  const init = () => {
    createChildren()
    enable()
  }

  return {
    init,
    enable,
    disable
  };
}

export default initialAriaFocus;
